import React from "react";
import Layout from "@/components/Layout";

const Doc = ({ title, sections }) => (
  <Layout>
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <h1 className="font-display text-4xl font-extrabold text-lawn-ink">{title}</h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: June 2026</p>
      <div className="mt-8 space-y-6">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-display text-xl font-bold text-lawn-ink">{s.h}</h2>
            <p className="text-muted-foreground mt-2 leading-relaxed">{s.b}</p>
          </section>
        ))}
      </div>
    </div>
  </Layout>
);

export function Terms() {
  return <Doc title="Terms of Service" sections={[
    { h: "1. Acceptance of Terms", b: "By accessing LawnLink Pro, you agree to these terms. LawnLink Pro is a marketplace connecting homeowners with independent lawn care and landscaping providers." },
    { h: "2. Marketplace Role", b: "LawnLink Pro facilitates bookings and payments but does not directly provide lawn care services. Providers are independent contractors responsible for the quality of their work." },
    { h: "3. Payments & Commissions", b: "Customers pay through the platform via Stripe. Providers may choose a monthly subscription or a 15% commission on completed jobs. Sponsored placements and featured boosts are billed as one-time charges." },
    { h: "4. Reviews", b: "Reviews must reflect genuine experiences. LawnLink Pro reserves the right to moderate reviews that violate our guidelines." },
    { h: "5. Cancellations", b: "Bookings may be canceled or rescheduled subject to the provider's policy. Refunds are handled per our refund policy." },
    { h: "6. Liability", b: "LawnLink Pro is not liable for damages arising from services performed by independent providers." },
  ]} />;
}

export function Privacy() {
  return <Doc title="Privacy Policy" sections={[
    { h: "1. Information We Collect", b: "We collect account information (name, email), property addresses for service delivery, booking history, and payment details processed securely by Stripe." },
    { h: "2. How We Use Data", b: "To match you with providers, process bookings and payments, send notifications, and improve the platform via our AI agents that analyze aggregate platform data." },
    { h: "3. Data Sharing", b: "We share necessary booking details with providers to fulfill your service. We never sell your personal data." },
    { h: "4. Security", b: "Passwords are hashed, sessions are encrypted, and payments are handled by PCI-compliant Stripe. We use secure cookies and tokens." },
    { h: "5. Your Rights", b: "You can access, update, or delete your account data at any time by contacting support." },
    { h: "6. Cookies", b: "We use cookies for authentication and analytics to improve your experience." },
  ]} />;
}
